import { Search } from 'lucide-react';
import { useSearchParams } from 'react-router-dom';
import { Input } from '@/components/ui/input';
import { useLeadFilters } from '@/hooks/useLeadFilters.ts';
import {
  clearLeadFilterParams,
  writeLeadFiltersToSearchParams,
} from '@/models/ui/leadFilterSearchParams.ts';
import { type SearchQuery, SearchQueryBrand } from '@/models/ui/search.ts';

export function SearchInput() {
  const [searchParams, setSearchParams] = useSearchParams();
  const filters = useLeadFilters();
  const searchQuery = searchParams.get('q') || '';

  const handleSearchChange = (value: SearchQuery) => {
    let nextParams = new URLSearchParams(searchParams);
    const isStartingSearch = value.length > 0 && searchQuery.length === 0;

    if (isStartingSearch) {
      nextParams = clearLeadFilterParams(nextParams);
    }

    nextParams = writeLeadFiltersToSearchParams(nextParams, {
      ...filters,
      statuses: isStartingSearch ? [] : filters.statuses,
      urgencies: isStartingSearch ? [] : filters.urgencies,
      contactabilities: isStartingSearch ? [] : filters.contactabilities,
      search: value,
    });

    setSearchParams(nextParams, { replace: true });
  };

  return (
    <div className="relative">
      <Search className="absolute left-3 top-1/2 transform -translate-y-1/2 w-4 h-4 text-gray-400" />
      <Input
        type="search"
        id="global-search"
        name="q"
        aria-label="Search leads"
        placeholder="Search leads by title, customer, equipment, or priority"
        className="w-80 pl-9 h-8 bg-white text-black placeholder:text-gray-400 border-0"
        value={searchQuery}
        onChange={(e) =>
          handleSearchChange(SearchQueryBrand.parse(e.target.value))
        }
      />
    </div>
  );
}
